import { type IFileObjectDTO } from '../../../models/fileObjects';
import { baseLearningTools } from '../fixtures/content';
import { clone } from '../support/clone';

/**
 * Returns the mock learning tools.
 */
export function getDevMockLearningTools(): IFileObjectDTO[] {
  return clone(baseLearningTools);
}
